import { useCallback, useEffect, useRef } from 'react';

export const useIsMounted = () => {
  const isMounted = useRef(false);

  const safeSetState = useCallback((callback, ...args) => {
    if (isMounted.current) {
      callback(...args);
    }
  }, []);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return [
    useCallback(() => isMounted.current, []) as unknown as boolean,
    safeSetState,
  ] as [boolean, <T>(callback: (...args: T[]) => void, ...args: T[]) => void];
};

export default useIsMounted;
